import React, { useContext } from 'react';
import QuickFilters from './QuickFilters';
import QuickFiltersScroller from './QuickFiltersScroller';
import BoardContext from '../../../contexts/BoardContext';
import PerformanceBoardSlideOutContext from '../../PerformanceBoards/contexts/PerformanceBoardSlideOutContext';
import useBoardQuickFilterCounts from './useBoardQuickFilterCounts';

const QuickFiltersContainer = ({
  onQuickFilterChanged,
  showCounts = true,
}: {
  onQuickFilterChanged?: () => void;
  showCounts?: boolean;
}) => {
  const { board, quickFilters, selectedQuickFilters, setSelectedQuickFilters } =
    useContext(BoardContext);
  const { setIsOpen, isOpen } = useContext(PerformanceBoardSlideOutContext);
  const { quickFilterOrder } = board;
  const onFilterToggled = (filter: LegacySavedFilter) => {
    if (isOpen) {
      setIsOpen(false);
    }
    const isSelected = selectedQuickFilters.some((f) => f.id === filter.id);
    if (isSelected) {
      setSelectedQuickFilters((fs) => fs.filter((f) => f.id !== filter.id));
    } else {
      setSelectedQuickFilters((fs) => [...fs, filter]);
    }
    if (onQuickFilterChanged) {
      onQuickFilterChanged();
    }
  };

  const orderedFilters = quickFilterOrder
    .map((filterId) => quickFilters.find((f) => f.id === filterId))
    .filter((f) => !!f) as LegacySavedFilter[];
  const filtersNotInOrder = quickFilters.filter(
    (f) => !quickFilterOrder.includes(f.id),
  );
  orderedFilters.push(...filtersNotInOrder);

  const countsById = useBoardQuickFilterCounts({ isEnabled: showCounts });

  return (
    <QuickFiltersScroller>
      <QuickFilters
        quickFilters={orderedFilters}
        onFilterToggled={onFilterToggled}
        selectedQuickFilters={selectedQuickFilters}
        countsById={countsById}
      />
    </QuickFiltersScroller>
  );
};

export default QuickFiltersContainer;
